(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40502],{

/***/ 31624:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warrantyfor.house",
      function () {
        return __webpack_require__(35103);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ WarrantyForHouseHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_warrantyforhouse_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47590);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_warrantyForHouseWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91973);
/* harmony import */ var _components_warrantyforhouse_benefits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45016);
/* harmony import */ var _components_warrantyforhouse_howIsHomeWarranty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68327);
/* harmony import */ var _components_warrantyforhouse_whatIsHomeWarranty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64989);
/* harmony import */ var _components_warrantyforhouse_whatAreBenefits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64357);
/* harmony import */ var _components_warrantyforhouse_liesBeneath__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78739);
/* harmony import */ var _components_warrantyforhouse_leaveHome__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78861);
/* harmony import */ var _components_shared_newJerseyDisclaimer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70988);






const OffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});







var __N_SSP = true;
function WarrantyForHouseHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_warrantyForHouseWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_whatIsHomeWarranty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OffersList, {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_howIsHomeWarranty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_whatAreBenefits__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_liesBeneath__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_benefits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_warrantyforhouse_leaveHome__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_newJerseyDisclaimer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                backGround: "#fffaef"
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,91973,45828,49774,92888,40179], function() { return __webpack_exec__(31624); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);